import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import Entry from './Entry'
import store from './store'

export default function Root() {
  return (
    <Provider store={store}>
      <Router basename="/api/zoomapp/proxy">
        <Entry />
      </Router>
    </Provider>
  )
}
